import React from "react";
import { ContractDataTable } from "./ContractDataTable";
import { YhBox } from "@src/components/YhBox";

export const ContractDataBox: React.FC = () => {

  const action = (
    <>
    </>
  );

  return (
    <YhBox action={action} style={{ height: 'calc(100vh - 230px)' }}>
      <ContractDataTable />
    </YhBox>
  );
}